import { getToken, getUid, getVcode } from '../store/token';
import qs from 'qs';
import { config_api_proxy_host, config_pclogin_proxy_host, config_sync_proxy_host } from '../../imsdk/api';
import * as ImSdk from '../../imsdk/api';
import { defaultHeader } from '../../imsdk/net/http';
import { showToast } from '../components/Toast';
import { NetConnected } from '../../App';
import { Str_AuthorizeHadExpired, Str_NetworkConnectFail } from '../language/string_res';
const JsonBig = require('json-bigint')({ storeAsString: true });
import { NativeModules } from 'react-native';
import globalEventBus from '../utils/EventBus';
import log from '../../imsdk/log';

// export const UploadUrl = 'http://fs.jifeng.online/';
export const ErrorCodePermission = 1003; // 多点登陆异常
export const ErrorCodeNeedUpdate = 426; // API不兼容

const defaultConfig: RequestConfig = {
	method: 'GET',
	useToken: true,
	keepalive: true,
};

export interface RequestConfig extends Omit<RequestInit, 'body'> {
	method?: 'GET' | 'POST' | 'DELETE' | 'PUT';
	params?: object;
	body?: object;
	useToken?: boolean;
	debug?: boolean;
}

export type ResponseContext<D, C = any> = {
	code: number;
	data?: D;
	config?: C;
	msg?: string;
	err?: any;
};

export const request = <D, C>(
    url: string,
    config: RequestConfig,
): Promise<ResponseContext<D, C>> => {
    // Web 环境下总是启用调试日志
    const isWeb = typeof window !== 'undefined';
    const shouldDebug = config.debug || isWeb;
    
    function logger(...str: any[]) {
        if (shouldDebug) {
            console.log(...str);
        }
    }

    const requestConfig: RequestConfig = Object.assign(
        {},
        defaultConfig,
        config,
    );
    const requestInit: RequestInit = {};
    requestInit.headers = defaultHeader();
    requestInit.method = requestConfig.method || 'GET';
    if (requestConfig.headers) {
        requestInit.headers = Object.assign(
            {},
            defaultHeader(),
            requestConfig.headers,
        );
    }

    const token = getToken();
    const uid = getUid();

    if (requestConfig.useToken) {
        logger(getToken());
        (requestInit.headers as any)['X-Token'] = token;
    }

    if (requestConfig.params) {
        logger('>>> fetch params: ', requestConfig.params);
        url += '?' + qs.stringify(requestConfig.params);
    }

    if (requestConfig.method === 'POST') {
        logger('>>> fetch post body: ', requestConfig.body);
        requestInit.body = JSON.stringify(requestConfig.body || {});
    }

    //202507-09 添加 v2
    if (!/^http(s?):/.test(url) && !url.includes(config_pclogin_proxy_host())  && !url.includes(config_api_proxy_host()) && !url.includes(config_sync_proxy_host())) {
        if (url.startsWith('/sync')) {
            url = config_sync_proxy_host() + url;
        } else if (url.startsWith('/v1/pc/login')) {
            url = config_pclogin_proxy_host() + url;
        } else {
            url = config_api_proxy_host() + url;
        }
    }

    console.log('===>>>> start fetch2222: ' + url);
    
    // 详细的请求日志（Web 环境下总是显示）
    if (config.debug || typeof window !== 'undefined') {
        console.group('🌐 [HTTP Request]');
        console.log('URL:', url);
        console.log('Method:', requestInit.method);
        console.log('Headers:', requestInit.headers);
        if (requestConfig.params) {
            console.log('Query Params:', requestConfig.params);
            console.log('Query String:', url.split('?')[1] || '');
        }
        if (requestConfig.body) {
            console.log('Request Body:', requestConfig.body);
            console.log('Request Body (JSON):', requestInit.body);
        }
        console.log('Full Request Config:', requestInit);
        console.groupEnd();
    }
    
    if (url.startsWith('/sync')) {
        console.log('>>> start fetch: ' + JSON.stringify(requestInit));
        console.log('>>> start fetch: ' + NetConnected.isConnected);
        console.log('>>> start fetch: ' + url);
    }

    if (NetConnected.isConnected === false) {
        return new Promise((resolve) => {
            resolve({ code: -1, msg: Str_NetworkConnectFail, })
        })
    }

    async function onErrorCodePermission(uid: number, token: string, res?: any) {
        const auth = await ImSdk.getInstance().getAuth(uid);
        if (auth && auth.auth && auth.auth.token !== token) {
            // 说明是重新登录的已经登录过的账号
            return
        }
        const msg = res.msg || res.message || Str_AuthorizeHadExpired;
        ImSdk.getInstance().emit('auth_fail', { auth_fail: { vcode: getVcode(), msg }, });
    }

    return fetch(url, requestInit)
        .then((res) => {
            if (res.status === 200) {
                return res.json()
            }
            if (res.status === 408) {
                return { code: -1, msg: Str_NetworkConnectFail, message: Str_NetworkConnectFail }
            }
            return { code: -1, msg: Str_NetworkConnectFail, message: Str_NetworkConnectFail }
        })
        .then((json) => {
            console.log('>>> end fetch[' + json.code + ']: ' + url);
            
            // 详细的响应日志（Web 环境下总是显示）
            if (config.debug || typeof window !== 'undefined') {
                console.group('✅ [HTTP Response]');
                console.log('URL:', url);
                console.log('Status Code:', json.code);
                console.log('Response Data:', json);
                if (json.msg) {
                    console.log('Message:', json.msg);
                }
                console.groupEnd();
            }
            
            // logger('>>> response data: ', JSON.stringify(json));
            // 多点登陆提示
            if (json.code === ErrorCodePermission) {
                log.info('会话已经失效 333', json.code);
                onErrorCodePermission(uid, token, json);
            }
            return json;
        })
        .catch((err) => ({ code: -1, msg: err.message, err }));
};

// export const getJson = <D, C = any>(url: string, config?: RequestConfig) =>
//     request<D, C>(url, { ...config, method: 'GET' });

export const postJson = <D, C = any>(url: string, config?: RequestConfig) => request<D, C>(url, { ...config, method: 'POST' });

// export const upload = <T>(
//     url: string,
//     body: FormData,
// ): Promise<T extends {} ? { [x in keyof T]: T[x] } & { err?: any } : any> => {
//     console.log('>>> upload: ', url);
//     return fetch(url, { body, method: 'POST' })
//         .then((res) => res.json())
//         .then<any>((json) => {
//             return json;
//         })
//         .catch((err) => ({ err }));
// };
